export enum UserRole {
  Admin = "Admin",
  Digitador = "Digitador",
  Cliente = "Cliente",
}

export default UserRole;
